import { CURRENCY, Money } from "../../utils/money";

export interface IBalance {
    current: {
        balance: Money[];
        last_updated_at: string;
    };
    history: {
        balance: Money[],
        timestamp: string,
    }[]

}

export interface ILedgerEntry {
    id: number;
    txid: string;
    tx_type: TransactionType;
    amount: number;
    currency: CURRENCY;
    description: string;
    tx_time: string;
    created_at: string;
    performed_by: string | null;
  }

export enum TransactionType {
    CREDIT = "CREDIT",
    DEBIT = "DEBIT"
}


export enum BalanceHistoryPeriod {
    LAST_24_HOURS = "24h",
    LAST_WEEK = "7d",
    LAST_MONTH = "30d",
    LAST_YEAR = "1y",
}
